import React, { useState } from "react";
import axios from "axios";

import {
  Button,
  Image,
  Row,
  Card,
  Form,
  Input,
  Space,
  Typography,
  Spin,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { images, SIZES, COLORS } from "../../constants";

import { Link } from "react-router-dom";
import Notification from "../shared/Notification";
import BackgroundContainer from "../../v2/components/BackgroundContainer/BackgroundContainer";

const formItemLayout = {
  wrapperCol: {
    xs: { span: 10 },
    sm: { span: 24 },
  },
};

const { Paragraph, Title } = Typography;

function Login() {
  const [forms] = Form.useForm();
  const [isLoading, setisLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState(false);
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: COLORS.white }} spin />
  );

  const onFinish = (values) => {
    setisLoading(true);
    passwordreset(values);
  };

  const passwordreset = async (data) => {
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/password-reset`,
      data: data,
    })
      .then(({ data }) => {
        setEmailStatus(data.isSent);
        forms.resetFields();
        Notification(
          "Email Sent!",
          "The link to reset your password has been sent to your email",
          "success"
        );
      })
      .catch((error) => {
        Notification("Error occured!", error + "!", "error");
      })
      .finally(() => setisLoading(false));
  };

  return (
    <BackgroundContainer>
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
      >
        <Form
          form={forms}
          {...formItemLayout}
          name="password-forgot"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Space direction="horizontal" size={"small"}>
            <Image
              preview={false}
              src={images.gensanLogo}
              className="logo"
              width={100}
              style={{ margin: "10px 5px 10px 5px" }}
            />

            <Image
              src={images.tourismLogo}
              preview={false}
              className="tourismLogo"
              width={250}
            />
          </Space>
          <Row justify="center" align="middle">
            <Card style={{ borderRadius: SIZES.base, width: 320, height: 250 }}>
              {emailStatus ? (
                <Row justify="center" align="middle">
                  <center style={{ marginBottom: SIZES.base * 3 }}>
                    <Title level={4}>Email has been sent!</Title>
                    <Paragraph>
                      You can open the link sent to your email to change your
                      password
                    </Paragraph>
                    <Link to={"/"}>
                      <Paragraph style={{ color: COLORS.blue1 }}>
                        Go back to login!
                      </Paragraph>
                    </Link>
                  </center>
                </Row>
              ) : (
                <>
                  <center style={{ marginBottom: SIZES.base * 3 }}>
                    <Title level={4}>Forgot Password</Title>
                    <Paragraph>
                      Enter your email to reset your password
                    </Paragraph>
                  </center>

                  <Form.Item
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: "The input is not valid E-mail!",
                      },
                      {
                        required: true,
                        message: "Please input your E-mail!",
                      },
                    ]}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100%", marginBottom: SIZES.body2 }}
                    >
                      {isLoading ? (
                        <Row
                          justify="center"
                          align="middle"
                          style={{ width: "100%" }}
                        >
                          <Spin indicator={antIcon} />
                        </Row>
                      ) : (
                        <>Reset Password</>
                      )}
                    </Button>
                  </Form.Item>
                </>
              )}
            </Card>
          </Row>
        </Form>
      </Row>
    </BackgroundContainer>
  );
}

export default Login;
